function setCookie(name, value) {
  const cookie = `${name}=${value}; Path=/; SameSite=Strict; Secure`;
  document.cookie = cookie;
}

function checkForCookie(name) {
  try {
    const res = document.cookie
      .split(';')
      .find((row) => row.startsWith(name))
      .split('=')[1];

    return parseInt(res) === 1;
  } catch (e) {
    return null;
  }
}

export { setCookie, checkForCookie };
